import { AboutSection } from "../components/AboutSection";
import { AwardsLanguages } from "../components/AwardsLanguages";
import { ContactSection } from "../components/ContactSection";
import { ExperienceEducation } from "../components/ExperienceEducation";
import { Hero } from "../components/Hero";
import { Highlights } from "../components/Highlights";
import { ProjectsSection } from "../components/ProjectsSection";
import { ResearchSection } from "../components/ResearchSection";
import { SkillsSection } from "../components/SkillsSection";
import { StackManifest } from "../components/StackManifest";
import { StructuredData } from "../components/StructuredData";
import { WebAnalytics } from "../components/WebAnalytics";

export function HomePage() {
  return (
    <main id="main-content">
      <StructuredData />
      <WebAnalytics />
      <Hero />
      <Highlights />
      <AboutSection />
      <ProjectsSection />
      <ResearchSection />
      <ExperienceEducation />
      <SkillsSection />
      <AwardsLanguages />
      <StackManifest />
      <ContactSection />
    </main>
  );
}
